import { render, staticRenderFns } from "./ClinicConfig.vue?vue&type=template&id=6e2dbbbc&scoped=true"
import script from "./ClinicConfig.vue?vue&type=script&lang=js"
export * from "./ClinicConfig.vue?vue&type=script&lang=js"
import style0 from "./ClinicConfig.vue?vue&type=style&index=0&id=6e2dbbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2dbbbc",
  null
  
)

export default component.exports